import { useForm } from "react-hook-form";
import { RxReload } from "react-icons/rx";
// import useBasicLogin from "../../hooks/auth/useBasicLogin";
import { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"; // Import eye icons
import Input from "../ui/Input";

const UsernamePassword = () => {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });
  //   const { handleLoginUser, loginUser } = useBasicLogin();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="w-[69.5%] space-y-4 form-container">
      <Input
        control={control}
        label={"Email"}
        name={"email"}
        placeholder={"Please Enter Email"}
        rules={{
          required: "Email is required",
        }}
      />
      <div className="relative">
        <Input
          control={control}
          label={"Password"}
          type={showPassword ? "text" : "password"} // Toggle type
          name={"password"}
          placeholder={"Please Enter Password"}
          rules={{
            required: "Password is required",
          }}
        />
        {/* Eye Icon for Toggle */}
        <button
          type="button"
          className="absolute right-3 top-[50%] transform  text-gray-500 icon-position"
          //   onClick={() => setShowPassword(!showPassword)}
        >
          {/* {showPassword ? (
            <AiOutlineEyeInvisible className="w-5  h-5 icon-size" />
          ) : (
            <AiOutlineEye className="w-5 h-5 icon-size" />
          )} */}
        </button>
      </div>
      <button
        // onClick={handleSubmit(handleLoginUser)}
        // disabled={loginUser.isLoading}
        className=" bg-primary w-full rounded-md py-2 text-white login-button"
      >
        <div className=" flex items-center justify-center space-x-3 login-button-content">
          <span>Login</span>
          {/* {loginUser.isLoading && <RxReload className=" animate-spin animate-spin" />} */}
        </div>
      </button>
    </div>
  );
};

export default UsernamePassword;
